/** Official GYSUMO butterfly logo (image asset). variant: "full" | "butterfly" */
export default function Logo({ variant = "full", className = "", alt = "GYSUMO – Kunst & Poesie" }) {
  const src = variant === "butterfly" ? "/gysumo-butterfly.png" : "/gysumo-logo.png";
  return <img src={src} alt={alt} className={className} draggable="false" />;
}
